var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMorev({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26347 4.26335C9.45882 4.068 9.72377 3.95825 10 3.95825C10.2763 3.95825 10.5413 4.068 10.7366 4.26335C10.932 4.4587 11.0417 4.72365 11.0417 4.99992C11.0417 5.27618 10.932 5.54114 10.7366 5.73649C10.5413 5.93184 10.2763 6.04159 10 6.04159C9.72377 6.04159 9.45882 5.93184 9.26347 5.73649C9.06812 5.54114 8.95837 5.27618 8.95837 4.99992C8.95837 4.72365 9.06812 4.4587 9.26347 4.26335ZM9.26347 9.26335C9.45882 9.068 9.72378 8.95825 10 8.95825C10.2763 8.95825 10.5413 9.068 10.7366 9.26335C10.932 9.4587 11.0417 9.72365 11.0417 9.99992C11.0417 10.2762 10.932 10.5411 10.7366 10.7365C10.5413 10.9318 10.2763 11.0416 10 11.0416C9.72378 11.0416 9.45882 10.9318 9.26347 10.7365C9.06812 10.5411 8.95837 10.2762 8.95837 9.99992C8.95837 9.72365 9.06812 9.4587 9.26347 9.26335ZM9.26347 14.2633C9.45882 14.068 9.72378 13.9583 10 13.9583C10.2763 13.9583 10.5413 14.068 10.7366 14.2633C10.932 14.4587 11.0417 14.7237 11.0417 14.9999C11.0417 15.2762 10.932 15.5411 10.7366 15.7365C10.5413 15.9318 10.2763 16.0416 10 16.0416C9.72378 16.0416 9.45882 15.9318 9.26347 15.7365C9.06812 15.5411 8.95837 15.2762 8.95837 14.9999C8.95837 14.7237 9.06812 14.4587 9.26347 14.2633Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorev);
export default __webpack_public_path__ + "static/media/morev.db92c1bb43c42b1dd026cae5284112a5.svg";
export { ForwardRef as ReactComponent };